import React, { useContext } from "react";
import {
    Carousel,
    CarouselItem,
    CarouselIndicators,
    CarouselControl,
} from 'reactstrap';
import { Link, useNavigate } from "react-router-dom";
import { ProductContext } from "../ProductContext";
import Banner from "./Banner"
import ScrollToTopOnMount from "./ScrollToTopOnMount";

function Home() {



    return (
        <>
            <ScrollToTopOnMount />
            <Banner />
            <div className="d-flex flex-column py-4">
            <div className="d-flex justify-content-center" >
                <Link to="/products" className="btn btn-primary bg-black" replace>
                Browse products
                </Link>
            </div>
            </div>

        </>
    );
}

export default Home;